import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Title } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { BoxCTA } from '../../atoms/BoxCTA/BoxCTA';
import { TextCTA } from '../../atoms/TextCTA/TextCTA';
import { BottomShadowCurtain, ModalContent, ModalContentWrapper, ModalFooter, ModalOverlay, ModalPortal, ModalRoot, ModalSurface, ModalTrigger } from './Modal.styles';
export const Modal = ({ children, isOpen, ...props })=>/*#__PURE__*/ _jsxs(ModalRoot, {
        onOpenChange: 'newApi' in props ? undefined : props.onOpenChange,
        open: isOpen,
        children: [
            !('newApi' in props) && Boolean(props.triggerComponent) && /*#__PURE__*/ _jsx(ModalTrigger, {
                asChild: true,
                children: props.triggerComponent
            }),
            /*#__PURE__*/ _jsxs(ModalPortal, {
                children: [
                    /*#__PURE__*/ _jsx(ModalOverlay, {}),
                    /*#__PURE__*/ _jsxs(ModalSurface, {
                        onPointerDownOutside: 'newApi' in props ? props.onPointerDownOutside : props.onSecondaryButtonClick,
                        children: [
                            /*#__PURE__*/ _jsxs(ModalContentWrapper, {
                                children: [
                                    /*#__PURE__*/ _jsx(VisuallyHidden, {
                                        children: /*#__PURE__*/ _jsx(Title, {
                                            children: 'newApi' in props ? props.title : ''
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ModalContent, {
                                        className: 'newApi' in props ? undefined : props.className,
                                        children: children
                                    }),
                                    /*#__PURE__*/ _jsx(BottomShadowCurtain, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ModalFooter, {
                                children: 'newApi' in props ? props.footerContent : /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        Boolean(props.onPrimaryButtonClick && props.primaryButtonLabel) && /*#__PURE__*/ _jsx(BoxCTA, {
                                            as: "button",
                                            isDisabled: props.isPrimaryButtonDisabled,
                                            onClick: props.onPrimaryButtonClick,
                                            children: props.primaryButtonLabel
                                        }),
                                        /*#__PURE__*/ _jsx(TextCTA, {
                                            as: "button",
                                            "data-testid": "button-modal-close",
                                            onClick: props.onSecondaryButtonClick,
                                            children: props.secondaryButtonLabel
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });

//# sourceMappingURL=Modal.js.map